export default __webpack_public_path__ + "static/media/header-bg.7da7bcff.svg";